import React from 'react';
import { Button, Stack, Typography, Box } from '@mui/material';

import { DialogTitle, DialogContent, DialogActions } from '/packages/shared-components/Dialog/Dialog';

export interface RemoveSetModalProps {
  handleModalClose: () => void;
  onDiscard: () => void;
}

const RemoveSetModal = ({ handleModalClose, onDiscard }: RemoveSetModalProps) => {
  return (
    <Box sx={{ width: '444px' }}>
      <DialogTitle sx={{ textAlign: 'center' }}>Remove Set</DialogTitle>
      <DialogContent>
        <Stack gap={3}>
          <Typography variant="body1">
            Removing this test set will permanently delete it from the list and its current order. Do you want to
            proceed?{' '}
          </Typography>
        </Stack>
      </DialogContent>
      <DialogActions>
        <Stack direction="row" gap={2}>
          <Button variant="text" size="small" onClick={handleModalClose}>
            Cancel
          </Button>
          <Button variant="contained" size="small" onClick={onDiscard}>
            Remove
          </Button>
        </Stack>
      </DialogActions>
    </Box>
  );
};

export default RemoveSetModal;
